import React, { useCallback, useEffect, useRef, useState } from 'react';
import { MentionsInput, Mention } from 'react-mentions';
import uploadSvg from '../../../assets/img/upload.svg';
import sendSvg from '../../../assets/img/send.svg';
import ScheduleMessagePicker from '../../../components/ScheduleMessagePicker';
import ScheduledMessagesList, { fmtScheduledTimeLabel } from '../../../components/ScheduledMessagesList';
import SidebarModal from '../../../components/SidebarModal';
import UpdateProjectForm from '../forms/UpdateProjectForm';
import { useAuth } from '../../../contexts/AuthContext';
import APIServices from '../../../services/APIServices';
import { hasPermission, selectLoader } from '../../../utils/Helpers';
import SignOffForm from '../forms/SignOffForm';
import ChangeOrderModal from '../updatedOverviewModals/ChangeOrderModal';
import ActivityCard from '../../../components/ActivityCard';
import AddQuoteModal from '../updatedOverviewModals/AddQuoteModal';
import ReqFeedbackModal from '../updatedOverviewModals/ReqFeedbackModal';
import closeIcon from '../../../assets/img/close.svg';
import fileImg from '../../../assets/img/file.svg';
import nickUser2 from '../../../assets/img/nick-user2.png';
import RequestModal from '../updatedOverviewModals/RequestModal';
import { fetchProjectTeamMembers } from '../../../utils/fetchData';
import appToast, { TOAST_TYPE } from 'utils/AppToast';
import ModalCenter from 'components/ModalCenter';
import { useNavigate } from 'react-router-dom';

const ActivityTab = ({
  setCurrentTab,
  currentTab,
  projectId,
  setSelectedReqId,
  memberPermission,
  userRole,
  isInternalProject,
  isFutureProject,
  isDraftProject = false,
  projectTeam
}) => {
  const scrollRef = useRef(null);
  const fileInputRef = useRef(null);
  const { user, isUser1, userId, socket } = useAuth();
  const navigate = useNavigate();
  // const [projectId, setProjectId] = useState("");
  const [isQouteRequired, setQouteRequired] = useState(false);
  const [changeReqId, setChangeReqId] = useState('');
  const [message, setMessage] = useState('');
  const [attachments, setAttachments] = useState([]);
  const attachmentsRef = useRef([]);
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1); // Default to page 1
  const [messageLoader, setMessageLoader] = useState(false);
  const messageSubmissionInProgressRef = useRef(false);
  const [signOffRequired, setSignOffRequired] = useState(false);
  const [updatedMilestoneId, setUpdatedMilestoneId] = useState('');
  const [mentionUsers, setMentionUsers] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const hasMoreRef = useRef(true);
  const activityPageRequestsInProgressRef = useRef(new Set());
  const [scheduledAt, setScheduledAt] = useState('');
  const [lastScheduledLabel, setLastScheduledLabel] = useState('');
  const [showScheduledList, setShowScheduledList] = useState(false);
  const [scheduledCount, setScheduledCount] = useState(0);

  useEffect(() => {
    return () => {
      attachmentsRef.current.forEach(({ previewUrl }) => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
      });
    };
  }, []);

  const [modals, setModals] = useState({
    updateModal: false,
    signOffModal: false,
    changeOrderModal: false,
    requestModal: false,
    requestFeedbackModal: false,
    addQuoteModal: false
  });

  useEffect(() => {
    setSelectedReqId('');
  }, []);

  const fetchScheduledCount = useCallback(async () => {
    if (!projectId) return;
    try {
      const res = await APIServices.get(`/scheduled-messages?projectId=${projectId}&type=activity`);
      setScheduledCount(Array.isArray(res) ? res.length : 0);
    } catch {}
  }, [projectId]);

  useEffect(() => {
    fetchScheduledCount();
  }, [fetchScheduledCount]);

  useEffect(() => {
    if (currentTab == 1 && projectId && user) {
      setActivities([]);
      setError(null);
      setHasMore(true);
      hasMoreRef.current = true;
      setCurrentPage(1);
      fetchActivities();
      setSelectedReqId('');
      fetchTeamMembers();
    }
  }, [currentTab, user, projectId]);

  //this functiion will fetch the list of users for the mentions in chat
  const fetchTeamMembers = async () => {
    let members = await fetchProjectTeamMembers(projectId, undefined, '');
    let membersWithoutUser = members?.filter((x) => x.value != user?._id);
    const formattedMembers = membersWithoutUser?.map((member) => ({
      id: member.value,
      display: member.label,
      avatar: member.profilePic || nickUser2
    }));
    setMentionUsers(formattedMembers);
    // console.log(formattedMembers);
  };

  const fetchActivities = async (page = 1) => {
    if (!projectId) return;

    const requestProjectId = projectId.toString();
    const requestKey = `${requestProjectId}:${page}`;
    if (activityPageRequestsInProgressRef.current.has(requestKey)) return;

    activityPageRequestsInProgressRef.current.add(requestKey);
    try {
      setLoading(true);
      setError(null);

      const response = await APIServices.get(`/project-activity?projectId=${requestProjectId}&page=${page}&limit=10`);

      const newData = response.data || [];

      if (page == 1) {
        setActivities([...newData].reverse());
        setCurrentPage(1);
      } else if (newData.length > 0) {
        const scrollContainer = scrollRef.current;
        const previousScrollHeight = scrollContainer?.scrollHeight;
        const previousScrollTop = scrollContainer.scrollTop;

        setActivities((prev) => [...[...newData].reverse(), ...prev]);

        setTimeout(() => {
          const newScrollHeight = scrollContainer?.scrollHeight;
          scrollContainer.scrollTop = previousScrollTop + (newScrollHeight - previousScrollHeight);
        }, 0);
        setCurrentPage(page);
      }

      // ✅ HAS MORE LOGIC (VERY IMPORTANT)
      const more = newData.length === 10;
      setHasMore(more);
      hasMoreRef.current = more;
    } catch (error) {
      setError(error.message);
    } finally {
      activityPageRequestsInProgressRef.current.delete(requestKey);
      setLoading(false);
    }
  };
  const toggleModal = (modalType, isOpen) => {
    setModals((prevState) => ({
      ...prevState,
      [modalType]: isOpen
    }));
  };

  const updateandCloseModal = (modalType) => {
    setModals((prevState) => ({
      ...prevState,
      [modalType]: false
    }));
    // fetchActivities();
  };

  useEffect(() => {
    if (currentPage === 1) {
      const cleanup = scrollToBottom();
      return cleanup; // ensures timeout is cleared on unmount
    }
  }, [activities, currentPage]);

  const scrollToBottom = () => {
    // Delay to wait for DOM render
    const timeout = setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
      }
    }, 100);

    // Optional: clear timeout if component unmounts
    return () => clearTimeout(timeout);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        // Check if the scrollTop is at the top of the div
        if (scrollRef.current.scrollTop === 0 && projectId && !loading && hasMoreRef.current) {
          fetchActivities(currentPage + 1); // Fetch the next page
        }
      }
    };

    const currentRef = scrollRef.current;
    if (currentRef) {
      currentRef.addEventListener('scroll', handleScroll);
    }

    // Clean up the event listener
    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handleScroll);
      }
    };
  }, [currentPage, projectId, loading, hasMore]);

  // Function to handle file uploads
  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    const newAttachments = files.map((file) => ({
      file,
      previewUrl: file.type.startsWith('image/') ? URL.createObjectURL(file) : null
    }));

    setAttachments((prevAttachments) => {
      const nextAttachments = [...prevAttachments, ...newAttachments];
      attachmentsRef.current = nextAttachments;
      return nextAttachments;
    });
    if (event.target) event.target.value = '';
  };

  // Function to remove an attachment
  const removeAttachment = (index) => {
    setAttachments((prevAttachments) => {
      const removedAttachment = prevAttachments[index];
      if (removedAttachment?.previewUrl) URL.revokeObjectURL(removedAttachment.previewUrl);

      const nextAttachments = prevAttachments.filter((_, i) => i !== index);
      attachmentsRef.current = nextAttachments;
      return nextAttachments;
    });
  };

  const formatScheduledAt = (val) => {
    if (!val) return '';
    const d = new Date(val);
    return d.toLocaleString([], { dateStyle: 'medium', timeStyle: 'short' });
  };

  // Function to handle sending the message
  const handleSendMessage = async () => {
    if (messageSubmissionInProgressRef.current) return;

    if (isDraftProject) {
      appToast('Activity messages cannot be sent while the project is in draft.', TOAST_TYPE.ERROR);
      return;
    }

    if ((!message || message.trim() === '') && attachments.length === 0) {
      appToast('Please enter a message or attachment to send.', TOAST_TYPE.ERROR);
      return;
    }

    messageSubmissionInProgressRef.current = true;
    setMessageLoader(true);
    const formData = new FormData();
    const messageUserTags = [];
    const regex = /@\[([^\]]+)\]\(([^)]+)\)/g;
    let processedMessage = message;
    let match;

    while ((match = regex.exec(message)) !== null) {
      const tagname = match[1];
      const userId = match[2];
      messageUserTags.push({ tagname, userId });
      processedMessage = processedMessage.replace(match[0], `@${tagname} `);
    }

    attachments.forEach(({ file }) => formData.append('attachments', file));
    formData.append('message', processedMessage);
    formData.append('projectId', projectId);
    formData.append('message_user_tags', JSON.stringify(messageUserTags));

    try {
      if (scheduledAt) {
        formData.append('type', 'activity');
        formData.append('scheduledAt', scheduledAt);
        await APIServices.post('/scheduled-messages', formData, { 'Content-Type': 'multipart/form-data' });
        appToast(`Message scheduled for ${formatScheduledAt(scheduledAt)}`, TOAST_TYPE.SUCCESS);
        setLastScheduledLabel(fmtScheduledTimeLabel(scheduledAt));
        setScheduledAt('');
        fetchScheduledCount();
      } else {
        await APIServices.post('/project-activity', formData, { 'Content-Type': 'multipart/form-data' });
      }
      setMessage('');
      attachments.forEach(({ previewUrl }) => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
      });
      attachmentsRef.current = [];
      setAttachments([]);
    } catch (error) {
      console.error('Error sending message:', error);
      appToast('Failed to send message. Please try again.', TOAST_TYPE.ERROR);
    } finally {
      messageSubmissionInProgressRef.current = false;
      setMessageLoader(false);
    }
  };

  useEffect(() => {
    // Listen for 'projectActivityUpdate' event
    if (!socket || !projectId) return;

    const appendCurrentProjectActivity = (activity) => {
      if (activity?.projectId?.toString() !== projectId?.toString()) return;

      setActivities((prevActivities) => [...prevActivities, activity]);
      scrollToBottom();
    };

    const handleProjectRequest = (activity) => appendCurrentProjectActivity(activity);
    const handleProjectUpdate = (activity) => appendCurrentProjectActivity(activity);
    const handleProjectMilestoneFeedback = (activity) => appendCurrentProjectActivity(activity);
    const handleProjectRequestQuote = (activity) => appendCurrentProjectActivity(activity);
    const handleProjectActivity = (activity) => appendCurrentProjectActivity(activity);
    const handleMilestone = (activity) => appendCurrentProjectActivity(activity);

    socket.on('ProjectRequest', handleProjectRequest);
    socket.on('ProjectUpdate', handleProjectUpdate);
    socket.on('ProjectMilestoneFeedback', handleProjectMilestoneFeedback);
    socket.on('ProjectRequestQuote', handleProjectRequestQuote);
    socket.on('ProjectActivity', handleProjectActivity);
    socket.on('Milestone', handleMilestone);

    return () => {
      socket.off('ProjectRequest', handleProjectRequest);
      socket.off('ProjectUpdate', handleProjectUpdate);
      socket.off('ProjectMilestoneFeedback', handleProjectMilestoneFeedback);
      socket.off('ProjectRequestQuote', handleProjectRequestQuote);
      socket.off('ProjectActivity', handleProjectActivity);
      socket.off('Milestone', handleMilestone);
    };
  }, [socket, projectId]);

  // if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="card-body-content" ref={scrollRef}>
      {/* {loading ? selectLoader(80) :
    } */}
      {loading && <div>{selectLoader(50)}</div>}

      {activities.length > 0 &&
        activities.map((activity, index) => (
          <ActivityCard
            key={activity._id}
            activity={activity}
            setCurrentTab={setCurrentTab}
            id={`item_${index}`}
            setSelectedReqId={setSelectedReqId}
          />
        ))}

      <div className="user-chatBox-cover">
        {!isDraftProject && (
          <ul className="chat-btn-list">
            {hasPermission(userRole, 'update_projects', memberPermission) && (
              <>
                <li>
                  <a
                    className="cursor_pointer"
                    onClick={() => {
                      if (isFutureProject) {
                        appToast('Cannot update the project with a future start date', TOAST_TYPE.ERROR);
                        return;
                      }
                      toggleModal('updateModal', true);
                    }}>
                    + Update
                  </a>
                </li>
              </>
            )}

            {hasPermission(userRole, 'send_signoff_requests', memberPermission) && (
              <li>
                <a className="cursor_pointer" onClick={() => toggleModal('signOffModal', true)}>
                  + Sign-Off
                </a>
              </li>
            )}

            {hasPermission(userRole, 'change_order', memberPermission) && (
              <li>
                <a
                  className="cursor_pointer"
                  onClick={() => {
                    toggleModal('changeOrderModal', true);
                  }}>
                  + Change Order
                </a>
              </li>
            )}
            {hasPermission(userRole, 'change_request', memberPermission) && (
              <li>
                <a className="cursor_pointer" onClick={() => toggleModal('requestModal', true)}>
                  + Request
                </a>
              </li>
            )}
            {hasPermission(userRole, 'feedback_request', memberPermission) && (
              <li>
                <a className="cursor_pointer" onClick={() => toggleModal('requestFeedbackModal', true)}>
                  + Request Feedback
                </a>
              </li>
            )}
          </ul>
        )}
        {!isDraftProject && (
          <div className="chat-msg-cover ">
          {/* <div className="chat-userList">
            <li>
              <img src={nickUser2} alt="nickUser2" className="nickUser" />
              <p>All</p>
            </li>
            <li>
              <img src={nickUser} alt="nickUser" className="nickUser" />
              <p>Rocco</p>
            </li>
            <li>
              <img src={nickUser2} alt="nickUser2" className="nickUser" />
              <p>TJ Sokoll</p>
            </li>
          </div> */}
          <div className="upload-cover">
            {attachments.map(({ file, previewUrl }, index) => (
              <div className="upload-box" key={index}>
                <img
                  src={closeIcon}
                  className="closeicon"
                  onClick={() => removeAttachment(index)}
                  alt="Remove attachment"
                />
                <img
                  src={previewUrl || fileImg}
                  className="fileimg"
                  alt={file.name}
                />
                <div className="upload-text">
                  <p>{file.name}</p>
                  <span>{(file.size / 1024).toFixed(2)} KB</span>
                </div>
              </div>
            ))}
            {/* <div className="upload-box3">
          <label htmlFor="fileUpload">
            <img src={adduploadPic} className="adduploadPic" alt="Upload" />
          </label>
          <input
            id="fileUpload"
            type="file"
            style={{ display: "none" }}
            multiple
            onChange={handleFileUpload}
          />
        </div> */}
          </div>
          {scheduledAt && (
            <div className="schedule-info-bar">
              <span>⏰ Sending at {formatScheduledAt(scheduledAt)}</span>
              <img src={closeIcon} className="schedule-clear-icon cursor_pointer" alt="Clear" onClick={() => setScheduledAt('')} />
            </div>
          )}
          {!scheduledAt && lastScheduledLabel && (
            <div className="schedule-info-bar schedule-info-bar--confirm">
              <span>⏰ Your message will be sent {lastScheduledLabel}.</span>
              <span className="schedule-see-all cursor_pointer" onClick={() => setShowScheduledList(true)}>See all scheduled messages</span>
            </div>
          )}
          {scheduledCount > 0 && !lastScheduledLabel && (
            <div className="schedule-pending-bar" onClick={() => setShowScheduledList(true)}>
              <span>⏰ {scheduledCount} scheduled message{scheduledCount > 1 ? 's' : ''}</span>
              <span className="schedule-pending-bar__view">View all →</span>
            </div>
          )}
          <ScheduledMessagesList
            projectId={projectId}
            type="activity"
            show={showScheduledList}
            onClose={() => { setShowScheduledList(false); fetchScheduledCount(); }}
            onMessagesChange={(messages) => {
              setScheduledCount(messages.length);
              if (messages.length === 0) setLastScheduledLabel('');
            }}
          />
          <div className="send-msg-text">
            <label htmlFor="reqfileUpload">
              <img src={uploadSvg} className="upload-icon cursor_pointer" alt="Upload" />
            </label>

            <input
              ref={fileInputRef}
              id="reqfileUpload"
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              multiple
              onChange={handleFileUpload}
            />

            {/* Mentions Input */}
            <div style={{ position: 'relative', flex: 1 }}>
              <MentionsInput
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="formControl"
                placeholder="Type your message..."
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    handleSendMessage();
                  }
                }}>
                <Mention
                  trigger="@"
                  data={mentionUsers}
                  displayTransform={(id, display) => `@${display} `}
                  renderSuggestion={(suggestion) => (
                    <>
                      <img src={suggestion.avatar} alt="nickUser2" className="nickUser" />
                      <p>{suggestion.display}</p>
                    </>
                  )}
                />
              </MentionsInput>
            </div>

            {/* Send / Schedule Button */}
            <div className="send-msg-split">
              <div className={`send-msg-cover ${scheduledAt ? 'send-msg-cover--scheduled' : ''}`} onClick={handleSendMessage}>
                {messageLoader ? selectLoader(15) : <img src={sendSvg} alt="Send" />}
              </div>
              <ScheduleMessagePicker onSchedule={(iso) => setScheduledAt(iso)} />
            </div>
          </div>
          </div>
        )}
      </div>

      <ModalCenter
        extraClass={'updatedRequest-modal'}
        show={modals.requestModal}
        headerTitle={'Submit a Request'}
        // closeModal={() => {
        //   toggleModal('requestModal', false);
        // }}
        closeModal={() => {
          // call child logic instead
          document.dispatchEvent(new Event('requestModalClose'));
        }}>
        <RequestModal
          projectId={projectId}
          closeModal={() => {
            updateandCloseModal('requestModal');
          }}
          onCloseRequestModal={() => {
            toggleModal('requestModal', false);
          }}
        />
      </ModalCenter>

      <ModalCenter
        extraClass={'updatedSignOff-modal'}
        show={modals.signOffModal}
        headerTitle={'Sign-off Request'}
        closeModal={() => {
          toggleModal('signOffModal', false);
        }}>
        <SignOffForm
          updatedMilestoneId={updatedMilestoneId}
          projectId={projectId}
          isInternalProject={isInternalProject}
          closeModal={() => {
            updateandCloseModal('signOffModal');
            setUpdatedMilestoneId('');
          }}
        />
      </ModalCenter>
      {/* <SidebarModal
        extraClass={'edit-profile-modal'}
        show={modals.requestFeedbackModal}
        onHide={() => toggleModal('requestFeedbackModal', false)}
        headerTitle={'Request Feedback'}>
        <ReqFeedbackModal
          isInternalProject={isInternalProject}
          projectId={projectId}
          closeModal={() => {
            updateandCloseModal('requestFeedbackModal');
          }}
        />
      </SidebarModal> */}
      <ModalCenter
        extraClass={'updatedSignOff-modal'}
        show={modals.requestFeedbackModal}
        headerTitle={'Request Feedback'}
        closeModal={() => {
          toggleModal('requestFeedbackModal', false);
        }}>
        <ReqFeedbackModal
          isInternalProject={isInternalProject}
          projectId={projectId}
          closeModal={() => {
            updateandCloseModal('requestFeedbackModal');
          }}
        />
      </ModalCenter>
      <SidebarModal
        extraClass={'edit-profile-modal'}
        show={modals.addQuoteModal}
        onHide={() => toggleModal('addQuoteModal', false)}
        headerTitle={'Quote'}>
        <AddQuoteModal
          projectId={projectId}
          changeReqId={changeReqId}
          closeModal={() => {
            updateandCloseModal('addQuoteModal');
          }}
        />
      </SidebarModal>
      <ModalCenter
        extraClass={'updatedRequest-modal'}
        show={modals.changeOrderModal}
        headerTitle={'Change Order'}
        closeModal={() => {
          toggleModal('changeOrderModal', false);
        }}>
        <ChangeOrderModal
          projectId={projectId}
          setChangeReqId={setChangeReqId}
          setQouteRequired={setQouteRequired}
          closeModal={() => {
            if (isQouteRequired == true) {
              setModals((prevState) => ({
                ...prevState,
                addQuoteModal: true,
                changeOrderModal: false
              }));
            } else {
              updateandCloseModal('changeOrderModal');
            }
          }}
        />
      </ModalCenter>
      {/* <SidebarModal
        extraClass={'edit-profile-modal'}
        show={modals.updateModal}
        onHide={() => toggleModal('updateModal', false)}
        headerTitle={'Update Project'}> */}
        <ModalCenter
        extraClass={'milestoneupdated-modal'}
        show={modals.updateModal}
        headerTitle={'Update Project'}
        closeModal={() => {
          toggleModal('updateModal', false);
        }}>
        {
          <UpdateProjectForm
            projectId={projectId}
            setSignOffRequired={setSignOffRequired}
            closeModal={() => {
              // if (updatedMilestoneId) {
              //   console.log("updatedMilestoneId", updatedMilestoneId);
              //   toggleModal("updateModal", false);
              //   toggleModal("signOffModal", true);
              // } else {
              //   setUpdatedMilestoneId("");
              updateandCloseModal('updateModal');
              // }
            }}
          />
        }
        </ModalCenter>
      {/* </SidebarModal> */}
      {/* <SidebarModal
        extraClass={'edit-profile-modal'}
        show={modals.signOffModal}
        onHide={() => {
          toggleModal('signOffModal', false);
          setUpdatedMilestoneId('');
        }}
        headerTitle={'Sign-off Request'}>
        <SignOffForm
          updatedMilestoneId={updatedMilestoneId}
          projectId={projectId}
          closeModal={() => {
            updateandCloseModal('signOffModal');
            setUpdatedMilestoneId('');
          }}
        />
      </SidebarModal> */}
    </div>
  );
};

export default ActivityTab;
